import { adminRoutes } from 'modules/admin/routes/constants';

export const donationsTabelRoutes = {
  root: `${adminRoutes.root}/donations`,
};
